import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    InputType,
    ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_42_users_add: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Users",
        style: {},
        childComponents: [
            // Back button in header
            {
                componentType: LayoutTypes.GROUP,
                BindValue: "cont_Action",
                style: {
                    direction: FlexDirection.ROW,
                    padding: 10,
                    marginBottom: 10,
                },
                childComponents: [
                    // {
                    //     componentType: ComponentType.BUTTON,
                    //     Label: "Back",
                    //     BindValue: "btn_add",
                    //     onPressAction: "navigate_back",
                    //     Navigate: "modulev1/user_summary",
                    //     style: {
                    //         backgroundColor: "#1f2937",
                    //         textColor: "#FFFFFF",
                    //         padding: 8,
                    //         borderRadius: 6,
                    //     },
                    // },
                ],
            },
            // Form
            {
                componentType: LayoutTypes.FORM,
                Name: "users_add",
                TableName: "users",
                columnNumber: "m1 t1 w3",
                SubmitActions: [
                    {
                        Action: "Navigate",
                        Navigate: "modulev1/user_summary",
                    },
                ],
                style: {
                    padding: 10,
                    backgroundColor: "#ffffff",
                    direction: FlexDirection.COLUMN,
                },
                childComponents: [
                    // User name (required)
                    {
                        componentType: ComponentType.TEXT_FIELD,
                        name: "txt_user_name",
                        label: "User name",
                        placeholder: "",
                        required: true,
                        inputType: InputType.TEXT,
                        Json_Attribute: "username",
                        BindValue: "txt_user_name",
                        validation: [
                            {
                                rule: ValidationRule.REQUIRED,
                                message: "User name is required",
                            },
                        ],
                    },
                    // Display name (required)
                    {
                        componentType: ComponentType.TEXT_FIELD,
                        name: "txt_display_name",
                        label: "Display name",
                        placeholder: "",
                        required: true,
                        inputType: InputType.TEXT,
                        Json_Attribute: "display_name",
                        BindValue: "txt_display_name",
                        validation: [
                            {
                                rule: ValidationRule.REQUIRED,
                                message: "Display name is required",
                            },
                        ],
                    },
                    // Email (required)
                    {
                        componentType: ComponentType.TEXT_FIELD,
                        name: "txt_email",
                        label: "Email",
                        placeholder: "",
                        required: true,
                        inputType: InputType.EMAIL,
                        Json_Attribute: "email",
                        BindValue: "txt_email",
                        validation: [
                            {
                                rule: ValidationRule.REQUIRED,
                                message: "Email is required",
                            },
                            {
                                rule: ValidationRule.EMAIL,
                                message: "Please enter a valid email address",
                            },
                        ],
                    },
                    // Password (optional)
                    {
                        componentType: ComponentType.TEXT_FIELD,
                        name: "txt_password",
                        label: "Password",
                        placeholder: "",
                        required: false,
                        inputType: InputType.PASSWORD,
                        Json_Attribute: "password",
                        BindValue: "txt_password",
                    },
                    // User code (auto-generated, readonly)
                    {
                        componentType: ComponentType.TEXT_FIELD,
                        name: "txt_user_code",
                        label: "User code",
                        placeholder: "Will be auto generated...",
                        required: false,
                        inputType: InputType.TEXT,
                        disabled: true,
                        Json_Attribute: "usercode",
                        BindValue: "txt_user_code",
                        AutoPopulate: true,
                        AutoPopulate_format: "USR_[******]",
                    },
                    // Group (required, Select with user_group lookup)
                    {
                        componentType: ComponentType.SELECT_DROPDOWN,
                        name: "drp_group",
                        label: "Group",
                        placeholder: "--Not Set--",
                        required: true,
                        lookupName: "user_group",
                        options: [],
                        Json_Attribute: "role_id",
                        BindValue: "drp_group",
                        validation: [
                            {
                                rule: ValidationRule.REQUIRED,
                                message: "Group is required",
                            },
                        ],
                    },
                    // Mobile (required)
                    {
                        componentType: ComponentType.TEXT_FIELD,
                        name: "txt_mobile",
                        label: "Mobile",
                        placeholder: "",
                        required: true,
                        inputType: InputType.PHONE,
                        Json_Attribute: "mobile_no",
                        BindValue: "txt_mobile",
                        validation: [
                            {
                                rule: ValidationRule.REQUIRED,
                                message: "Mobile is required",
                            },
                        ],
                    },
                    // User image (optional, Image upload)
                    {
                        componentType: ComponentType.IMAGE_UPLOAD,
                        name: "txt_user_image",
                        label: "User image",
                        placeholder: "",
                        required: false,
                        Json_Attribute: "image",
                        BindValue: "txt_user_image",
                        maxFiles: 1,
                        maxFileSize: 5, // 5MB
                        acceptedFileTypes: ["image/jpeg", "image/png", "image/jpg", "image/gif"],
                        previewEnabled: true,
                    },
                    // User File (optional, Files upload)
                    {
                        componentType: ComponentType.FILES,
                        name: "txt_user_file",
                        label: "User File",
                        placeholder: "",
                        required: false,
                        Json_Attribute: "attachment",
                        BindValue: "txt_user_file",
                        maxFiles: 5,
                        maxFileSize: 10, // 10MB
                    },
                    // Branches (required, Select with branches lookup)
                    {
                        componentType: ComponentType.SELECT_DROPDOWN,
                        name: "drp_branch",
                        label: "Branches",
                        placeholder: "--Not Set--",
                        required: true,
                        lookupName: "branches",
                        options: [],
                        Json_Attribute: "branch_id",
                        BindValue: "drp_branch",
                        validation: [
                            {
                                rule: ValidationRule.REQUIRED,
                                message: "Branch is required",
                            },
                        ],
                    },
                    // Enable branch switching (optional, Checkbox)
                    {
                        componentType: ComponentType.CHECKBOX,
                        name: "enable_branch_switching",
                        label: "Enable branch switching",
                        required: false,
                        Json_Attribute: "branch_switching",
                        BindValue: "enable_branch_switching",
                    },
                ],
            },
            // Footer buttons
            {
                componentType: LayoutTypes.GROUP,
                BindValue: "cont_Action",
                style: {
                    direction: FlexDirection.ROW,
                    padding: 16,
                    gap: 12,
                },
                childComponents: [
                    {
                        componentType: ComponentType.BUTTON,
                        Label: "Submit",
                        BindValue: "btn_submit",
                        onPressAction: "save",
                        ActionType: "Submit",
                        ScreenId: "42",
                        style: {
                            backgroundColor: "var(--primary-green)",
                            textColor: "#FFFFFF",
                            padding: 12,
                            borderRadius: 6,
                        },
                    },
                    // {
                    //     componentType: ComponentType.BUTTON,
                    //     Label: "Cancel",
                    //     BindValue: "btn_submit",
                    //     onPressAction: "navigate_back",
                    //     Navigate: "modulev1/user_summary",
                    //     style: {
                    //         backgroundColor: "#6b7280",
                    //         textColor: "#FFFFFF",
                    //         padding: 12,
                    //         borderRadius: 6,
                    //     },
                    // },
                ],
            },
        ],
    },
];
